import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    WarningMessage: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    WarningMessageText: {
        color: defaultPalette.orangeWarning.main,
    },
})
